import { formatOptions } from 'components/formInputs/SelectField/utils';
import { InputChoice } from 'components/formInputs/types';
import range from 'utils/range';

import { DepressionFormValues, Severity } from './types';

export const SEVERITIES: Array<InputChoice<Severity>> = [
  { label: 'Mild', value: 'mild' },
  { label: 'Moderate', value: 'moderate' },
  { label: 'Severe', value: 'severe' },
];

export const NUM_MEDICATIONS = formatOptions(range(0, 10));

export const LABELS: Record<keyof DepressionFormValues, string> = {
  currentlyTreated: 'Are you currently undergoing treatment for depression?',
  diagnosedAt: 'When we you diagnosed with depression?',
  everTreated: 'Have you ever taken medication or been in psychotherapy for depression?',
  hospitalized: 'Have you ever been hospitalized due to depression?',
  hospitalizedAt: 'When was the last hospitalization?',
  numberOfMedications: 'How many different types of medications are you currently taking?',
  psychotherapy: 'Are you currently in psychotherapy treatment?',
  severity: 'What was your diagnosis?',
  treatmentEndDate: 'When did your treatment (either medication or therapy) end?',
};
